import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { CheckboxIcon, CheckboxOutlineIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  FLOOR_BASE_OPTIONS,
  FLOOR_TYPE_OPTIONS,
} from "../../../data";
import { formKey } from "../../../hooks/useQuoteBoxStructure";
import { selectQuoteQuotationForm } from "../../../redux/selector";
import { quotesActions } from "../../../redux/slice";
import { CROSS_BEAMS_OPTIONS, QuoteQuotationForm } from "../../../types";
import { CHECKBOX_SIZE, NumberField, NumberedSectionTitle, SelectField } from "./FormFields";
import { useStyles } from "../styles";

const QuoteFloor = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const form = useSelector(selectQuoteQuotationForm);

  const updateField = (
    field: keyof QuoteQuotationForm,
    value: string | boolean
  ) => {
    dispatch(quotesActions.updateQuotationFormField({ field, value }));
  };

  return (
    <>
      <Box className={styles.inputCard}>
        <NumberedSectionTitle
          number={1}
          titleKey={formKey("SECTIONS.BOX_DIMENSIONS")}
        />
        <Box className={styles.grid2}>
          <NumberField
            labelKey={formKey("FIELDS.ASSEMBLED_LENGTH")}
            value={form.assembledLength}
            onChange={(value) => updateField("assembledLength", value)}
          />
          <NumberField
            labelKey={formKey("FIELDS.ASSEMBLED_WIDTH")}
            value={form.assembledWidth}
            onChange={(value) => updateField("assembledWidth", value)}
          />
        </Box>
      </Box>

      <Box className={styles.inputCard}>
        <NumberedSectionTitle
          number={2}
          titleKey={formKey("SECTIONS.FLOOR")}
        />
        <Box className={styles.floorGrid}>
          <SelectField
            labelKey={formKey("FIELDS.FLOOR_BASE")}
            value={form.floorBase}
            options={FLOOR_BASE_OPTIONS}
            onChange={(value) => updateField("floorBase", value)}
            compact
          />
          <SelectField
            labelKey={formKey("FIELDS.FLOOR_TYPE")}
            value={form.floorType}
            options={FLOOR_TYPE_OPTIONS}
            onChange={(value) => updateField("floorType", value)}
            grow
          />
          <NumberField
            labelKey={formKey("FIELDS.FLOOR_THICKNESS")}
            value={form.floorThickness}
            onChange={(value) => updateField("floorThickness", value)}
            compact
          />
          <SelectField
            labelKey={formKey("FIELDS.CROSS_BEAMS")}
            value={form.crossBeams}
            options={CROSS_BEAMS_OPTIONS}
            onChange={(value) => updateField("crossBeams", value)}
            grow
          />
        </Box>

        <Box className={styles.checkboxRow}>
          <Box className={styles.checkboxBox}>
            <Checkbox
              checked={form.reinforcedModel}
              onChange={(event) =>
                updateField("reinforcedModel", event.target.checked)
              }
              disableRipple
              icon={
                <CheckboxOutlineIcon
                  width={CHECKBOX_SIZE}
                  height={CHECKBOX_SIZE}
                />
              }
              checkedIcon={
                <CheckboxIcon width={CHECKBOX_SIZE} height={CHECKBOX_SIZE} />
              }
              sx={{ p: 0, width: CHECKBOX_SIZE, height: CHECKBOX_SIZE }}
            />
            <Typography className={styles.checkboxLabel}>
              {t(formKey("FIELDS.REINFORCED_MODEL"))}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default QuoteFloor;
